import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DynamicTable from '../sharedFiles/commonTable/dynamicTable';

const HistoryItem = ({ handleBack, historyItems, tabIndex }) => {
  
  return (
    <>
      <div className='backdiv col-12  mb-0 d-flex align-items-center'>
      <button onClick={handleBack} className="goBackButton">
      <ArrowBackIcon size={24}/>
      </button>
      <p className="m-0 fw-medium mx-2">{tabIndex === 0 ? 'SALES QUOTATION HISTORY' : 'SALES ORDER HISTORY'}</p>
      </div>
      <div className="TableDivz">
        <DynamicTable data={historyItems} pageName={tabIndex===0?'SALES QUOTATION HISTORY': 'SALES ORDER HISTORY'}/>
      </div>
    </>
  );
};

export default HistoryItem;
